<template>
    <div class="transfer-container">
        <div class="transfer-title">
            {{ $t("TRANSFERS") }}
        </div>

        <Sticky
            :top="89"
            :show="89"
            stickyClass="scroll_top_nav"
            :stickyShowBefore="true"
            :ignore="!isMobile ? true : false"
        >
            <div
                class="transfer-tabs"
                :class="{
                    empty: transferList.length === 0,
                }"
            >
                <div
                    class="transfer-tab-item btn-aspn-default"
                    :class="{ selected: i.selected }"
                    v-for="(i, index) in tabs"
                    :key="index"
                    @click="selectTab(i, tabs)"
                >
                    {{ $t(i.name) }}
                </div>
            </div>
        </Sticky>

        <LoadingAspn type="transfer" v-if="isLoading" />
        <div v-show="!isLoading">
            <div
                class="transfer-list"
                v-if="transferList.length > 0"
                ref="scrollContainer"
                @scroll="checkScrollBottom"
            >
                <template v-for="(i, index) in transferList" :key="index">
                    <div class="transfer-item" v-if="index < displayQuantity">
                        <div class="transfer-item-head">
                            <div class="transfer-amount">
                                <span v-if="selectedTab === 'extend'">
                                    {{ $t("RENEWAL") }}
                                </span>
                                <span v-else>
                                    {{ i.money ? $t("LOAN") : $t("FREE") }}
                                </span>
                            </div>
                            <div class="transfer-date">
                                {{ i.generateDate }}
                            </div>
                        </div>
                        <div class="transfer-team">
                            <Navigation
                                :id="i.id"
                                :category="'player'"
                                :name="i.name"
                            >
                                <Icon
                                    :logoUrl="i.logo"
                                    class="transfer-team-icon"
                                >
                                </Icon>
                            </Navigation>

                            <div class="transfer-team-data">
                                <Navigation
                                    :id="i.id"
                                    :category="'player'"
                                    :name="i.name"
                                >
                                    <div class="transfer-player-name">
                                        {{ i.name }}
                                    </div>
                                </Navigation>

                                <div class="transfer-position">
                                    {{ i.position }}
                                </div>
                            </div>
                            <Navigation
                                :id="i.toTeamId"
                                :category="'team'"
                                :name="i.toTeamName"
                            >
                                <Icon
                                    :logoUrl="i.toTeamLogo"
                                    class="transfer-team-icon"
                                >
                                </Icon>
                            </Navigation>
                        </div>
                        <div class="transfer-foot">
                            <div class="transfer-name-list">
                                <Navigation
                                    :id="i.fromTeamId"
                                    :category="'team'"
                                    :name="i.fromTeamName"
                                >
                                    <div class="transfer-name">
                                        {{ i.fromTeamName }}
                                    </div>
                                </Navigation>
                                <div>
                                    <SvgIcon
                                        icon="team.transfer.arrow.right"
                                    ></SvgIcon>
                                </div>
                                <Navigation
                                    :id="i.toTeamId"
                                    :category="'team'"
                                    :name="i.toTeamName"
                                >
                                    <div class="transfer-name">
                                        {{ i.toTeamName }}
                                    </div>
                                </Navigation>
                            </div>
                            <div class="transfer-contract-date">
                                <span class="bold">
                                    {{ $t("CONTRACT") }}:
                                </span>
                                {{ i.dateRange }}
                                <!-- Aug 2024 - Jun 2028 -->
                            </div>
                            <div class="transfer-market-value">
                                <span class="bold">
                                    {{ $t("MARKET_VALUE") }}:
                                </span>
                                {{ i.money ? `£${i.money}M` : "-" }}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="pa-05rem" v-else>
                <NoData />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "footballTeamTransfer",
    data() {
        return {
            displayQuantity: 10,
            tabs: [
                {
                    name: "PLAYERS_IN",
                    id: "in",
                    selected: true,
                },
                {
                    name: "PLAYERS_OUT",
                    id: "out",
                    selected: false,
                },
                {
                    name: "EXTENSION",
                    id: "extend",
                    selected: false,
                },
            ],
            selectedTab: "in",
        };
    },
    props: {
        isLoading: Boolean,
    },
    computed: {
        ...mapGetters(["teamInfo", "currentLanguageObj"]),
        transferList() {
            if (
                this.teamInfo.transfers &&
                this.teamInfo.transfers[this.selectedTab]
            ) {
                return this.teamInfo.transfers[this.selectedTab].player;
            } else {
                return [];
            }
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        // Vue 2 用这个，Vue 3 用 unmounted()
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            const scrollTop =
                window.scrollY || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = window.innerHeight;

            if (scrollTop + clientHeight >= scrollHeight - 10) {
                this.displayQuantity += 10;
            }
        },
        selectTab(i, tabs) {
            tabs.forEach((e) => {
                e.selected = false;
            });
            i.selected = true;
            this.selectedTab = i.id;
        },

        generateDate(playerDate) {
            if (!playerDate) {
                return "";
            }
            let options = {
                // weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",
            };
            playerDate = new Date(playerDate.split(".").reverse().join("-")); // Convert "05.09.2023" to "2023-09-05"
            let theDate = new Date(playerDate);
            return this.$tools.getDateByLocale(
                this.currentLanguageObj.apiParam.replace("_", "-"),
                options,
                theDate
            );
        },
        formatDateRange(date, endTime) {
            const startDate = new Date(date.split(".").reverse().join("-")); // Convert "05.09.2023" to "2023-09-05"
            const startMonth = this.$i18n.t(
                this.$tools.getMonth(startDate.getMonth())
            );
            const startYear = startDate.getFullYear();

            if (endTime) {
                const endDate = new Date(endTime);
                const endMonth = this.$t(
                    this.$tools.getMonth(endDate.getMonth())
                );
                const endYear = endDate.getFullYear();

                return `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
            }
            return `${startMonth} ${startYear}`;
        },
        onScroll() {
            const el = this.$refs.scrollContainer;

            // 判断是否到底
            const isBottom =
                el.scrollHeight - el.scrollTop <= el.clientHeight + 1;

            if (isBottom) {
                // this.loadNextPage(); // 你可以在这里调用加载函数
            }
        },
    },
};
</script>

<style scoped>
.transfer-container {
    padding: 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: var(--color-background-default-secondary);
}
.transfer-title {
    font-size: 16px;
    font-family: var(--weight-700);
    color: var(--color-text-default-default);
    margin-bottom: 24px;
    letter-spacing: 0.64px;
}
.transfer-tabs {
    display: flex;
    gap: 8px;
    margin-bottom: 24px;
}
.transfer-tab-item {
    padding: 8px 24px;
    box-sizing: border-box;
    border: 1px solid var(--color-border-default-default);
    color: var(--color-text-default-default);
    border-radius: 24px;
    cursor: pointer;
    font-family: var(--weight-600);
    letter-spacing: 0.64px;
}
.transfer-tab-item.selected {
    background-color: var(--color-background-brand-default);
    color: var(--color-button-active);
}
.transfer-tab-item:hover {
    background-color: var(--color-background-brand-default);
    color: var(--color-button-active);
}
.transfer-list {
    display: grid;
    grid-template-columns: repeat(3, calc(33% - 12px));
    gap: 24px;
}
.transfer-item {
    border: 1px solid var(--color-border-default-default);
    padding: 16px 24px;
    border-radius: 16px;
}
.transfer-item-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.transfer-amount {
    background: var(--color-background-invite-card);
    color: var(--color-text-default-neutral);
    width: 114px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 14px;
    letter-spacing: 0.64px;
}
.transfer-date {
    color: var(--color-text-default-secondary);
    font-size: 14px;
    letter-spacing: 0.64px;
}
.transfer-team {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 20px;
    padding: 12px 0 16px;
    font-size: 14px;
    letter-spacing: 0.64px;
}
.transfer-team-icon {
    width: 51.52px;
    height: 51.52px;
    border-radius: 50%;
}

.transfer-team-data {
}
.transfer-player-name {
    color: var(--color-text-default-default);
    font-family: var(--weight-700);
}
.transfer-position {
    margin-top: 4px;
    color: var(--color-text-default-secondary);
}
.transfer-foot {
    padding-top: 19px;
    border-top: 1px dotted var(--color-border-default-default);
}
.transfer-name-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 15px;
}
.transfer-name {
    width: 140px;
    flex-shrink: 0;
    font-size: 13px;
    text-align: center;
}
.transfer-contract-date {
    text-align: center;
    color: var(--color-text-default-secondary);
    font-size: 14px;
    letter-spacing: 0.64px;
}
.transfer-market-value {
    text-align: center;
    color: var(--color-text-default-secondary);
    font-size: 14px;
    letter-spacing: 0.64px;
}
.bold {
    font-family: var(--weight-700);
}

@media(max-width: 768px) {
    /* for test */
    .transfer-container {
        padding: 0 0 16px;
        background-color: var(--color-background-default-default);
        margin-bottom: 48px;
    }
    .transfer-list {
        padding: 0 8px;
        display: block;
    }
    .transfer-item {
        background-color: var(--color-background-default-secondary);
        margin-bottom: 8px;
    }
    .transfer-title {
        display: none;
    }
    .transfer-tabs {
        background-color: var(--color-background-default-secondary);
        margin-bottom: 16px;
        padding: 8px;
        border-bottom: 1px solid var(--color-border-default-default);
    }
    .transfer-tabs.empty {
        margin-bottom: 0;
    }
    .transfer-tab-item {
        flex: 1;
        text-align: center;
        padding: 8px;
        font-size: 13px;
    }
    .scroll_top_nav {
        top: 93px;
        border-bottom: 1px solid var(--color-border-default-default);
        width: 100%;
        background: var(--color-background-default-secondary);
        left: 0;
    }
}
</style>

